import React, { FC, useState } from "react";
import flags from "react-phone-number-input/flags";
import { Country } from "react-phone-number-input/input";
import styles from "./ContactNumberInput.module.css";
import { CustomerContact, Flag } from "../../types";
import Dropdown from "./Dropdown/Dropdown";
import InputField from "./Input/InputField";
import { getFromSessionStorage, StorageKeys } from "../../utils/Storage";

interface ContactNumberInputProps {
  value: string;
  onChange: (_contact: string, _flagIcon: Flag, _callingCode: string, _country: string, _ISO: Country) => void;
}

const ContactNumberInput: FC<ContactNumberInputProps> = ({ value, onChange }) => {
  const customerContactInfo = getFromSessionStorage(StorageKeys.CUSTOMER_CONTACT);
  let countryCode;
  let country;
  let iso;
  if (customerContactInfo) {
    const { _countryCode, _country, _ISO } = JSON.parse(customerContactInfo);
    countryCode = _countryCode;
    country = _country;
    iso = _ISO;
  }
  const [toggle, setToggle] = useState(false);
  const [customerContact, setCustomerContact] = useState<CustomerContact>({
    number: value,
    dialingCode: countryCode || "27",
    // eslint-disable-next-line
    // @ts-ignore
    image: flags[iso] || flags.ZA,
    ISO: iso || "ZA",
    country: country || "South Africa",
  });

  const onNumberChange = (contactNumber: string) => {
    setCustomerContact((prevState) => ({
      ...prevState,
      number: contactNumber,
    }));
    onChange(contactNumber, customerContact.image, customerContact.dialingCode, customerContact.country, customerContact.ISO);
  };
  const onCountryChange = (_flagIcon: Flag, _callingCode: string, _country: string, _ISO: Country) => {
    setCustomerContact((prevState) => ({
      ...prevState,
      dialingCode: _callingCode,
      image: _flagIcon,
      ISO: _ISO,
      country: _country,
    }));
    onChange(customerContact.number, _flagIcon, _callingCode, _country, _ISO);
  };

  return (
    <div className={styles.ContactNumberInput}>
      <div className={styles.Label}>Contact Number</div>
      <InputField
        toggle={{ current: toggle, set: setToggle }}
        value={customerContact}
        onChange={(contactNumber: string) => onNumberChange(contactNumber)}
      />
      <Dropdown
        toggle={{ current: toggle, set: setToggle }}
        onChange={(_flagIcon, _callingCode, _country, _ISO) => onCountryChange(_flagIcon, _callingCode, _country, _ISO)}
      />
    </div>
  );
};

export default ContactNumberInput;
